<app-base-template (modal)="openModal(content)"(searchmodal) = "searchModal()" (dataExportToExcel)="exportToExcel()" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)" 
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [showExportBtn]="showExportBtn" [showSearch]="showSearch"
                   [isExportDisable]="isExportDisable" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Map Support Group with Category</div>
  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>
    <label class="labelcolor" [hidden]="!isCategory">Category: </label>
    <div class="form-group category">
      <mat-checkbox class ="font-13" *ngFor="let category of categories" value="{{category.id}}" [(ngModel)]="category.checked">{{category.name}}</mat-checkbox>
    </div>
    <label class="labelcolor">Support group: </label>
    <div class="form-group">
      <mat-checkbox class ="font-13" *ngFor="let group of groups" value="{{group.id}}" [(ngModel)]="group.checked">{{group.name}}</mat-checkbox>
    </div>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>

<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>
  </div>
  <div class="modal-body">
      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder="Enter support group name"
                 [(ngModel)]="categrySelected">
      </div>
  </div>
  <div class="modal-footer pad-8">
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>

  </ng-template>
<notifier-container></notifier-container>


